import { back } from '../../../helpers/dataServer';

export const fetchClientes = async (token, filter) => {
  try {
    // Construcción dinámica de la URL
    let url = `${back}/clientes`;
    if (filter) {
      url += `?denominacion=${encodeURIComponent(filter)}`;
    }

    const response = await fetch(url, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (
      data.errors &&
      data.errors.status === 200 &&
      Array.isArray(data.errors.data)
    ) {
      return data.errors.data;
    } else {
      console.error(
        'Error: La API no devolvió una lista válida de clientes',
        data
      );
      return [];
    }
  } catch (error) {
    console.error('Error al obtener la lista de clientes:', error);
    return [];
  }
};

export const fetchUsuarioClientes = async (token, id) => {
  console.log(id);

  try {
    const response = await fetch(
      `${back}/usuarioclientes/listusuariosclientesid/${id}`,
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      }
    );
    const data = await response.json();

    if (data.status === 200 && Array.isArray(data.data)) {
      //return data.data.map((c) => c.id);
      return data.data;
    } else {
      console.error('Error al obtener clientes asignados:', data);
      return [];
    }
  } catch (error) {
    console.error('Error al obtener los clientes asignados:', error);
    return [];
  }
};
